import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import LiveClass from '../../domain/services/bbb/meeting/Index';

const initialState = {
  loading: 'idle',
  response: {},
  error: '',
};

export const teacherGetMyLiveClasses = createAsyncThunk(
  'teacher-get-classes-by-chunk',
  async function (classes: string[]) {
    return new LiveClass().teacherGetLiveClasses({
      _in: classes,
    });
  }
);

const getMyLiveClasses = createSlice({
  name: 'get_my_live_classes',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(teacherGetMyLiveClasses.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(teacherGetMyLiveClasses.fulfilled, (state, action) => {
      state.loading = 'success';
      state.response = action.payload;
    });
    builder.addCase(teacherGetMyLiveClasses.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
  },
});

const exportState = state => state.getLiveClassSlice;

export const teacherCreateLiveClassState = createSelector(exportState, obj => {
  return {
    response: obj.response.live_classes,
    loading: obj.loading,
  };
});

export default getMyLiveClasses.reducer;
